const getHeaders = () => {
  const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("ESGToken")}`,
      tenantId: localStorage.getItem("tenantId")? localStorage.getItem("tenantId"): "t001",
      userId: localStorage.getItem('userName') || 'userName'
    };
    return headers
};
export default getHeaders;
